import { ReactNode } from "react";
import {
  CLICKABLE,
  CMD_BASE,
  CMD_DANGER,
  CMD_FOOT,
  CMD_GHOST,
  CMD_PRIMARY,
  CMD_SMALL,
  CMD_YES,
  DISABLED,
} from "../styles";

/** .cmd-s in the bar, the wider .cmd-danger / .cmd-yes / .cmd-no below the divider. */
type Size = "bar" | "foot";
type Tone = "primary" | "ghost" | "danger" | "yes";

const SIZES: Record<Size, string> = {
  bar: CMD_SMALL,
  foot: CMD_FOOT,
};

const TONES: Record<Tone, string> = {
  primary: CMD_PRIMARY,
  ghost: CMD_GHOST,
  danger: CMD_DANGER,
  yes: CMD_YES,
};

type Props = {
  size: Size;
  tone: Tone;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
};

/**
 * The dock's pill button. Exists mainly to keep rule 2 from ../styles enforceable in
 * one place: size owns padding and font size, tone owns colours and weight, and the
 * cursor is set here rather than by the caller, so no property can end up declared
 * twice and lose to stylesheet order.
 */
export function CommandButton({ size, tone, disabled = false, onClick, children }: Props) {
  return (
    <button
      type="button"
      className={`${CMD_BASE} ${SIZES[size]} ${TONES[tone]} ${disabled ? DISABLED : CLICKABLE}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
